import React from 'react'; //eslint-disable-line no-unused-vars
import {getRouteDefinitions, redirectLocale} from 'epic-diesel-common/src/routes/Routes';
import ErrorView from '../pages/error/ErrorView';
import '../Plugins';

export default function getAppRoutes() {
    return [
        {path: '', exact: true, render: redirectLocale.bind(null, '/overview')},
        {path: 'home', exact: true, render: redirectLocale.bind(null, '/overview')},
        ...getRouteDefinitions(),
        {path: 'unexpected-error', exact: true, render: () => <ErrorView status={500} />},
        {path: '*', render: () => <ErrorView status={404} />}
    ]; // Concat app routes with routes defined as part of plugin provider
}
